import { useEffect, useState } from 'react'

import Button from '../ui/Button'
import Container from '../ui/Container'
import { heroSlides } from '../../data/site'

import './index.css'

function Hero() {
  const [activeSlide, setActiveSlide] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((current) => (current + 1) % heroSlides.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="hero relative overflow-hidden">
      <div className="hero-glow" />
      <div className="hero-pattern" />
      <Container className="relative z-10 py-24 sm:py-32 lg:py-40">
        <span className="text-xs font-bold uppercase tracking-widest text-accent-200">
          Meditex Healthcare Hub Limited
        </span>
        <h1 className="mt-4 max-w-2xl text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight transition-opacity duration-500">
          {heroSlides[activeSlide].heading}
        </h1>
        <p className="mt-4 max-w-xl text-base sm:text-lg text-primary-100 transition-opacity duration-500">
          {heroSlides[activeSlide].message}
        </p>
        <div className="mt-8 flex flex-wrap gap-4">
          <Button to="/contact" variant="primary">Book a Test</Button>
          <Button to="/services" variant="outline">Our Services</Button>
        </div>
      </Container>
      <div className="relative z-10 flex gap-2 justify-center pb-6">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.heading}
            onClick={() => setActiveSlide(i)}
            aria-label={`Show slide ${i + 1}`}
            className={`h-1.5 rounded-full transition-all ${i === activeSlide ? 'w-8 bg-coral' : 'w-4 bg-white/40'}`}
          />
        ))}
      </div>
    </div>
  )
}

export default Hero
